webpackJsonp([122553044697643],{

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _WingsAboveAmericasNationalParks = __webpack_require__(430);
	
	var _WingsAboveAmericasNationalParks2 = _interopRequireDefault(_WingsAboveAmericasNationalParks);
	
	var _WingsOverTheWest = __webpack_require__(431);
	
	var _WingsOverTheWest2 = _interopRequireDefault(_WingsOverTheWest);
	
	var _WesternExpress = __webpack_require__(429);
	
	var _WesternExpress2 = _interopRequireDefault(_WesternExpress);
	
	var _CowboysAndCanyons = __webpack_require__(428);
	
	var _CowboysAndCanyons2 = _interopRequireDefault(_CowboysAndCanyons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  title: "ATI Premium",
	  tours: [{
	    title: "Wings Above America's National Parks",
	    hero: _WingsAboveAmericasNationalParks2.default,
	    header: {
	      days: 15,
	      nights: 14,
	      start: "San Francisco",
	      end: "San Francisco"
	    },
	    highlights: ["Welcome reception", "Private Aircraft on all flight sectors", "Tour 17-Mile Drive and Monterey’s Cannery Row", "San Francisco Bay Cruise", "Comprehensive city tour of San Francisco", "Antelope Canyon tour", "Guided tour of Yosemite National Park", "Guided tour of Grand Canyon National Park", "Grand Canyon Picnic Lunch", "Ride the Grand Canyon Railway to Williams on Historic Route 66", "Comprehensive city tour of Los Angeles", "Free time to explore", "1 Lunch, 3 Dinners"],
	    optionals: ["Dinner in the Golden City: San Francisco", "Monument Valley Jeep tour", "Las Vegas Night Tour"],
	    body: "See America's National Parks from the air and ground including Yosemite, the Grand Canyon, Bryce and Zion. This is the ultimate way to sightsee and a truly one-of-a-kind experience."
	  }, {
	    title: "Wings Over the West",
	    hero: _WingsOverTheWest2.default,
	    header: {
	      days: 15,
	      nights: 14,
	      start: "Las Vegas",
	      end: "Las Vegas"
	    },
	    highlights: ["Daily Breakfast Included", "Welcome reception", "Private Aircraft on all flight sectors", "Comprehensive city tour of Los Angeles", "Guided tour of Grand Canyon National Park", "Guided tour of Yosemite National Park", "San Francisco Bay Cruise", "Comprehensive city tour of San Francisco", "Napa Valley and Sonoma with wine tasting and vineyard tour", "Tour 17-Mile Drive and Monterey’s Cannery Row", "Free time to explore", "Antelope Canyon Tour", "Visit Lake Powell, Zion and Monument Valley", "Grand Canyon Picnic Lunch"],
	    optionals: ["Dinner in the Golden City: San Francisco", "Los Angeles by Night Tour and Dinner", "Monument Valley Jeep Tour", "Las Vegas Night Tour"],
	    body: "This unique air/ground tour takes you from Los Angeles to the West Coast's must-see destinations of Las Vegas, the Grand Canyon, Yosemite National Park, the Wine Country, San Francisco and Monterey. Come discover the best of the American West."
	  }, {
	    title: "Western Express",
	    hero: _WesternExpress2.default,
	    header: {
	      days: 10,
	      nights: 9,
	      start: "Las Vegas",
	      end: "Las Vegas"
	    },
	    highlights: ["Daily Breakfast Included", "Welcome reception", "Private Aircraft on all flight sectors", "Tour 17-Mile Drive and Monterey’s Cannery Row", "San Francisco Bay Cruise", "Comprehensive city tour of San Francisco", "Guided tour of Yosemite National Park", "Comprehensive city tour of Los Angeles", "Free time to explore", "Napa Valley and Sonoma with wine tasting and vineyard tour"],
	    optionals: ["Dinner in the Golden City: San Francisco", "Guided tour to Grand Canyon National Park"],
	    body: " "
	  }, {
	    title: "Cowboys and Canyons",
	    hero: _CowboysAndCanyons2.default,
	    header: {
	      days: 7,
	      nights: 6,
	      start: "Las Vegas",
	      end: "Las Vegas"
	    },
	    highlights: ["Guided tour of Grand Canyon National Park", "Grand Canyon Picnic Lunch", "Ride the Grand Canyon Railway to Williams on Historic Route 66", "Napa Valley and Sonoma with wine tasting and vineyard tour", "Antelope Canyon Tour", "Visit Lake Powell, Monument Valley, Bryce Canyon and Zion National Parks", "Free time to explore", "Daily Breakfast Included"],
	    optionals: ["Monument Valley Jeep tour", "Las Vegas Night Tour"],
	    body: " "
	  }]
	}];
	module.exports = exports["default"];

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(8);
	
	__webpack_require__(7);
	
	var _Accordion = __webpack_require__(57);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shared = __webpack_require__(58);
	
	var _noMap = __webpack_require__(119);
	
	var _noMap2 = _interopRequireDefault(_noMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TourDisplay = function (_React$Component) {
	  _inherits(TourDisplay, _React$Component);
	
	  function TourDisplay(_ref) {
	    var items = _ref.items,
	        topLine = _ref.topLine,
	        small = _ref.small,
	        images = _ref.images,
	        text = _ref.text;
	
	    _classCallCheck(this, TourDisplay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      items: null,
	      topLine: null,
	      small: null,
	      title: null,
	      activeTour: null,
	      groupTitle: null,
	      images: null,
	      optionsText: ""
	    };
	
	    _this.handleUpdate = function (tourTitle, groupTitle) {
	      var i, j, k, y;
	      var tourReturn = null;
	      for (i = 0, j = _this.state.items.length; i < j; i++) {
	        if (_this.state.items[i].title == groupTitle) {
	          for (k = 0, y = _this.state.items[i].tours.length; k < y; k++) {
	            if (_this.state.items[i].tours[k].title == tourTitle) {
	              tourReturn = _this.state.items[i].tours[k];
	            }
	          }
	        }
	      }
	
	      _this.setState({
	        groupTitle: groupTitle,
	        activeTour: tourReturn
	      });
	    };
	
	    _this.isActive = function (title) {
	      return _this.state.activeTour.title == title;
	    };
	
	    _this.getActiveTour = function (groupTitle, tourTitle) {
	      var i, j, k, y;
	      var tourReturn = null;
	      for (i = 0, j = _this.state.items.length; i < j; i++) {
	        if (_this.state.items[i].title == groupTitle) {
	          for (k = 0, y = _this.state.items[i].tours.length; k < y; k++) {
	            if (_this.state.items[i].tours[k].title == tourTitle) {
	              tourReturn = _this.state.items[i].tours[k];
	            }
	          }
	        }
	      }
	    };
	
	    _this.renderTourSelector = function (data, title) {
	      var tours = [];
	      var i,
	          j,
	          temparray,
	          chunk = Math.ceil(data.length / 3);
	
	      if (chunk < 5) {
	        chunk = 5;
	      }
	
	      for (i = 0, j = data.length; i < j; i += chunk) {
	        temparray = data.slice(i, i + chunk);
	        var tourTitles = temparray.map(function (tour, tourKey) {
	          return _react2.default.createElement(
	            "li",
	            { key: tour.title, style: { width: '30' } },
	            _react2.default.createElement(
	              "button",
	              {
	                onClick: function onClick(event) {
	                  _this.handleUpdate(tour.title, title);
	                },
	                className: _this.isActive(tour.title) ? "is-active" : ""
	              },
	              tour.title
	            )
	          );
	        });
	        tours.push(tourTitles);
	      }
	
	      var groups = tours.map(function (group, groupKey) {
	        return _react2.default.createElement(
	          "ul",
	          { key: groupKey, className: "c-routes__list" },
	          group
	        );
	      });
	      return _react2.default.createElement(
	        "div",
	        { className: "c-routes" },
	        groups
	      );
	    };
	
	    _this.renderTourHighlights = function () {
	      if ("highlights" in _this.state.activeTour) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            { className: "t-h2 t-italic" },
	            "Tour Highlights Inclusions:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "c-ws__lists mt20" },
	            _react2.default.createElement(
	              "ul",
	              { className: "t-ul" },
	              _this.state.activeTour.highlights.map(function (highlight, highlightKey) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: highlightKey },
	                  highlight
	                );
	              })
	            )
	          )
	        );
	      }
	    };
	
	    _this.renderTourOptionals = function () {
	      if ("optionals" in _this.state.activeTour) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h3",
	            { className: "t-h2 t-italic" },
	            "Optional Experiences:"
	          ),
	          _react2.default.createElement(
	            "ul",
	            { className: "t-ul mt20" },
	            _this.state.activeTour.optionals.map(function (optional, optionalKey) {
	              return _react2.default.createElement(
	                "li",
	                { key: optionalKey },
	                optional
	              );
	            })
	          )
	        );
	      }
	    };
	
	    _this.getHeroImage = function () {
	      console.log(_this.state.activeTour.hero);
	      if (_this.state.activeTour.hero != null) {
	        return _this.state.activeTour.hero;
	      } else {
	        return _noMap2.default;
	      }
	    };
	
	    _this.state.items = items;
	    _this.state.topLine = topLine;
	    _this.state.small = small;
	    _this.state.groupTitle = items[0].title;
	    _this.state.activeTour = items[0].tours[0];
	    _this.state.images = images;
	    _this.state.optionsText = text;
	    return _this;
	  }
	
	  TourDisplay.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "c-golden t-context--light" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: "c-golden__short",
	          style: { display: "flex", flexDirection: "column", backgroundColor: "#eaebec" }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "c-golden__content",
	            style: { backgroundColor: "#eaebec" }
	          },
	          _react2.default.createElement(
	            "h1",
	            { className: "t-h1 mb30" },
	            this.state.optionsText
	          ),
	          _react2.default.createElement(
	            _Accordion2.default,
	            { stateReducer: _shared.single },
	            function (_ref2) {
	              var openIndexes = _ref2.openIndexes,
	                  handleItemClick = _ref2.handleItemClick;
	              return _react2.default.createElement(
	                "div",
	                {
	                  className: (0, _classnames2.default)("c-accordion", {
	                    "c-accordion--top-line": _this2.state.topLine,
	                    "c-accordion--small": _this2.state.small
	                  })
	                },
	                _this2.state.items.map(function (item, index) {
	                  return _react2.default.createElement(
	                    "div",
	                    {
	                      key: item.title,
	                      className: (0, _classnames2.default)("c-accordion__item", {
	                        "is-open": openIndexes.indexOf(index) >= 0
	                      })
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "c-accordion__btn t-h2",
	                        onClick: function onClick() {
	                          return handleItemClick(index);
	                        }
	                      },
	                      item.title
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "c-accordion__contents" },
	                      _this2.renderTourSelector(item.tours, item.title)
	                    )
	                  );
	                })
	              );
	            }
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "c-golden__images c-golden__short min-laptop",
	            style: { flex: "1" }
	          },
	          _react2.default.createElement("img", {
	            src: this.state.images[0],
	            alt: "",
	            style: { width: "50%" }
	          }),
	          _react2.default.createElement("img", {
	            src: this.state.images[1],
	            alt: "",
	            style: { width: "50%" }
	          }),
	          _react2.default.createElement("img", {
	            src: this.state.images[2],
	            alt: "",
	            style: { width: "100%" }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "c-golden__wide" },
	        _react2.default.createElement("img", {
	          src: this.getHeroImage(),
	          alt: "",
	          style: {
	            display: "block",
	            width: "100%"
	            // height: '100%',
	            // objectFit: 'cover',
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "c-golden__content c-golden__wide" },
	          _react2.default.createElement(
	            "div",
	            { className: "c-golden__text" },
	            _react2.default.createElement(
	              "div",
	              { className: "c-golden__text-col" },
	              _react2.default.createElement(
	                "div",
	                { className: "t-map-label mb20" },
	                this.state.groupTitle
	              ),
	              _react2.default.createElement(
	                "h1",
	                { className: "t-h1" },
	                this.state.activeTour.title
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "c-ws__header mt20" },
	                _react2.default.createElement(
	                  "h2",
	                  { className: "t-h2 t-red" },
	                  this.state.activeTour.header.days,
	                  " Days /",
	                  " ",
	                  this.state.activeTour.header.nights,
	                  " Nights",
	                  _react2.default.createElement(
	                    "small",
	                    { className: "t-small" },
	                    "\xA0",
	                    this.state.activeTour.header.breakfastText
	                  )
	                ),
	                _react2.default.createElement(
	                  "p",
	                  { className: "t-h3 t-bold" },
	                  "Begins in ",
	                  this.state.activeTour.header.start,
	                  " and ends in",
	                  " ",
	                  this.state.activeTour.header.end
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "tour_body mt30" },
	                this.state.activeTour.body
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "c-ws__content mt20" },
	                this.renderTourHighlights(),
	                this.renderTourOptionals()
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TourDisplay;
	}(_react2.default.Component);
	
	exports.default = TourDisplay;
	module.exports = exports["default"];

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CowboysAndCanyons.d301d804.jpg";

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WesternExpress.c890ad3e.jpg";

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WingsAboveAmericasNationalParks.1a16fa11.jpg";

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WingsOverTheWest.b2a012af.jpg";

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/airtours-1.92c446e7.jpg";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/airtours-2.a8ca97fb.jpg";

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/airtours-3.02911049.jpg";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/airtours-4.661459c7.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/airtours-5.e5c99473.jpg";

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/airtours-6.b8052902.jpg";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/airtours__hero.a208212d.jpg";

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/no-map.85b31c18.jpg";

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _TourDisplay = __webpack_require__(80);
	
	var _TourDisplay2 = _interopRequireDefault(_TourDisplay);
	
	var _airtours__hero = __webpack_require__(482);
	
	var _airtours__hero2 = _interopRequireDefault(_airtours__hero);
	
	var _airtours = __webpack_require__(476);
	
	var _airtours2 = _interopRequireDefault(_airtours);
	
	var _airtours3 = __webpack_require__(477);
	
	var _airtours4 = _interopRequireDefault(_airtours3);
	
	var _airtours5 = __webpack_require__(478);
	
	var _airtours6 = _interopRequireDefault(_airtours5);
	
	var _airtours7 = __webpack_require__(479);
	
	var _airtours8 = _interopRequireDefault(_airtours7);
	
	var _airtours9 = __webpack_require__(480);
	
	var _airtours10 = _interopRequireDefault(_airtours9);
	
	var _airtours11 = __webpack_require__(481);
	
	var _airtours12 = _interopRequireDefault(_airtours11);
	
	var _airTours = __webpack_require__(178);
	
	var _airTours2 = _interopRequireDefault(_airTours);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Airtours | What We Offer"
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _airtours__hero2.default },
	      _react2.default.createElement(
	        "h1",
	        { className: "t-hero" },
	        "Air Tours"
	      )
	    ),
	    _react2.default.createElement(
	      "main",
	      { id: "content" },
	      _react2.default.createElement(
	        "div",
	        { className: "c-golden t-context--light" },
	        _react2.default.createElement(
	          "div",
	          { className: "c-golden__images c-golden__short min-laptop" },
	          _react2.default.createElement("img", { src: _airtours2.default, alt: "", style: { width: '50%', height: '100%' } }),
	          _react2.default.createElement("img", { src: _airtours4.default, alt: "", style: { width: '50%', height: '50%' } }),
	          _react2.default.createElement("img", { src: _airtours6.default, alt: "", style: { width: '50%', height: '50%' } })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "c-golden__content c-golden__wide" },
	          _react2.default.createElement(
	            "ul",
	            { className: "c-breadcrumbs mb30" },
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/" },
	                "Home"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/what-we-offer" },
	                "What We Offer"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/what-we-offer/airtours", activeClassName: "is-active" },
	                "Air Tours"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "c-golden__text" },
	            _react2.default.createElement(
	              "div",
	              { className: "c-golden__text-col" },
	              _react2.default.createElement(
	                "h1",
	                { className: "t-h1" },
	                "A bird-eye view of the American West"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "t-p t-p-light mt30" },
	                "With over 40 years of experience in offering creative touring holidays to customers from all around the world, you can be assured that ATI\u2019s Air Tours have been meticulously planned with an emphasis on guest experience. Covering long distances by private aircraft, Air Tour customers will enjoy more time inside America\u2019s Great National Parks. Offering a more deluxe and inclusive experience, these tours have been designed to use the best mode of transportation between destinations so that customers can enjoy both getting there and being there."
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_TourDisplay2.default, {
	        items: _airTours2.default,
	        images: [_airtours8.default, _airtours10.default, _airtours12.default], text: "Airtour Options:" })
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-what-we-offer-airtours-js-74854a33a28c1f86eac3.js